import { jsx as _jsx } from "react/jsx-runtime";
import Alert from "@mui/material/Alert";
import { useUiTranslator } from "@plansoft-configuration-renderer/localization";
/**
 * Individual control on attribute level
 * - renders an alert by default
 * - meant to be overridden in custom renderers
 * @param props
 * @returns
 */
export function IndividualControl(_props) {
    const t = useUiTranslator();
    return (_jsx(Alert, { severity: "warning", children: t("ConfigurationRenderer:Warnings.componentNotSupported.IndividualControl", "Individual controls are not supported by the default renderer") }));
}
//# sourceMappingURL=IndividualControl.js.map